/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.fileTransfer', [])
    .factory('fileTransferService', FileTransferService)
    .name;

function FileTransferService($q, $http, $translate, types, gatewayCommandService) {
    var service = {
        fileAdded: fileAdded,
        fileUpload: fileUpload,
        sendFileToken: sendFileToken
    };
    return service;

    function fileAdded($file, $scope) {
        var deferred = $q.defer();
        var reader = new FileReader();
        reader.onload = function (event) {
            $scope.$apply(function () {
                if (event.target.result) {
                    var data = event.target.result;
                    if (data && data.length > 0) {
                        deferred.resolve({
                            importData: data.split(',')[1],
                            fileName: $file.name,
                            fileSize: $file.size
                        });
                    }
                }
            });
        };
        reader.readAsDataURL($file.file);
        return deferred.promise;
    }

    function fileUpload(gatewayId, fileInfo) {
        var deferred = $q.defer();
        var uploadStartInfo = {
            isModemFw: fileInfo.isModemFw,
            name: fileInfo.fileName,
            size: fileInfo.fileSize,
            b64ChunkLength: 32768,
            b64TotalLength: fileInfo.importData.length
        };

        var fileIsArchive = fileInfo.fileName.endsWith('.zip') || fileInfo.fileName.endsWith('.tar.gz');
        if (fileIsArchive && !fileInfo.decompressFile) {
            deferred.reject({data: $translate.instant('file-transfer.archive-but-decompress-not-selected')});
        } else if (!fileIsArchive && fileInfo.decompressFile) {
            deferred.reject({data: $translate.instant('file-transfer.not-archive-but-decompress-selected')});
        } else {
            gatewayCommandService.executeCommand(gatewayId,
                types.fileTransferCommand.fileUploadStart.value, uploadStartInfo).then(
                    (response) => {
                        if (response.error) {
                            if (angular.equals(response.error, types.gatewayCommandNotSupported.value)) {
                                deferred.reject({data: $translate.instant("gateway-command.not-supported")});
                            }
                        } else {
                            startChunkSending(gatewayId, fileInfo.importData, uploadStartInfo.b64ChunkLength, fileInfo.decompressFile, fileInfo.isModemFw).then(
                                (response) => {
                                    deferred.resolve(response);
                                },
                                (rejection) => {
                                    deferred.reject({ data: rejection });
                                }
                            );
                        }
                    },
                    (rejection) => {
                        deferred.reject({ data: rejection });
                    }
                );
        }
        return deferred.promise;
    }

    function startChunkSending(gatewayId, fileContent, chunkSize, decompress, isModemFw) {
        var deferred = $q.defer();
        var chunkArray = getChunkArray(fileContent, chunkSize);
        sendChunk(gatewayId, chunkArray, 0, decompress, isModemFw, deferred);
        return deferred.promise;
    }

    function sendChunk(gatewayId, chunkArray, chunkIndex, decompress, isModemFw, deferred) {
        gatewayCommandService.executeCommand(gatewayId,
            types.fileTransferCommand.fileUploadChunk.value, { data: chunkArray[chunkIndex] }).then(
                (response) => {
                    if (response.status === 'ok') {
                        if (chunkIndex < (chunkArray.length - 1)) {
                            chunkIndex++;
                            sendChunk(gatewayId, chunkArray, chunkIndex, decompress, isModemFw, deferred);
                        } else {
                            var uploadStopInfo = {
                                isModemFw: isModemFw,
                                decompress: decompress
                            };

                            gatewayCommandService.executeCommand(gatewayId,
                                types.fileTransferCommand.fileUploadStop.value, uploadStopInfo).then(
                                    (response) => {
                                        deferred.resolve(response.status);
                                    },
                                    (rejection) => {
                                        deferred.reject(rejection.data);
                                    }
                                );
                        }
                    } else {
                        deferred.reject(response.status);
                    }
                },
                (rejection) => {
                    deferred.reject(rejection.data);
                }
            );
    }

    function getChunkArray(base64string, chunkSize) {
        var chunkArray = [];
        while (base64string) {
            if (base64string.length < chunkSize) {
                chunkArray.push(base64string);
                break;
            } else {
                chunkArray.push(base64string.substr(0, chunkSize));
                base64string = base64string.substr(chunkSize);
            }
        }
        return chunkArray;
    }

    function sendFileToken(token) {
        var deferred = $q.defer();
        var url = '/auth/token';
        $http.post(url, token).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }
}



// WEBPACK FOOTER //
// ./src/app/api/file-transfer.service.js